import { I18n } from "@assets/strings";
import React from "react";
import { ClipLoader } from "react-spinners";
import styled, { useTheme } from "styled-components";
import { DeleteIcon } from "@ui/components/icons";
import { row } from "@ui/components/layout";

interface RoundedPlusButtonProps extends React.HTMLAttributes<HTMLDivElement> {
	label?: string;
	hideLabel?: boolean;
	inverted?: boolean;
	loading?: boolean;
}
export const RoundedPlusButton: React.FC<RoundedPlusButtonProps> = ({
	hideLabel,
	inverted,
	label,
	loading,
	...htmlProps
}) => {
	const theme = useTheme();
	return (
		<Container {...htmlProps} hideLabel={hideLabel} inverted={inverted}>
			{loading ? <ClipLoader size={18} color={theme.colors.secondary} /> : <DeleteIcon />}
			{!hideLabel && <div>{label ?? I18n.t(inverted ? "remove" : "add")}</div>}
		</Container>
	);
};

const Container = styled.div.withConfig({
	shouldForwardProp: (prop) => !["hideLabel", "inverted"].includes(prop),
})<{ hideLabel?: boolean; inverted?: boolean }>`
	cursor: pointer;
	flex-shrink: 0;
	${({ theme }) => theme.textStyles.text};
	background-color: ${({ theme, inverted }) => (inverted ? theme.colors.lightergray : theme.colors.secondaryLight)};
	border-radius: 4px;
	padding: ${({ hideLabel }) => (hideLabel ? "10px" : "4px 12px")};
	color: ${({ theme, inverted }) => (inverted ? theme.colors.textPrimary : theme.colors.secondary)};
	${row(6, "flex-start", "center")}
	> svg {
		width: 18px;
		height: 18px;
		transform: ${({ inverted }) => (inverted ? "none" : "rotate(45deg)")};
		path {
			fill: ${({ theme, inverted }) => (inverted ? theme.colors.textPrimary : theme.colors.secondary)};
		}
	}
`;
